// extracted by mini-css-extract-plugin
export var downArrow = "_bh-0";
export var label = "_bh-1";
export var treatmentCard = "_bh-3";
export var upArrow = "_bh-2";